var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgDetails(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.269,
    height: 18.781,
    viewBox: "0 0 14.269 18.781"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".kpmg-details_svg__cls-1,.kpmg-details_svg__cls-5{fill:none}.kpmg-details_svg__cls-1{stroke:#009ceb;stroke-width:1.6px;stroke-linecap:round;stroke-linejoin:round}.kpmg-details_svg__cls-4{stroke:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kpmg-details_svg__ICN_Detalii_Enabled",
    transform: "translate(-189.7 -259.697)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-details_svg__Group_1419",
    "data-name": "Group 1419",
    transform: "rotate(45 199.914 268.414)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-details_svg__Rectangle_412",
    "data-name": "Rectangle 412",
    className: "kpmg-details_svg__cls-1",
    transform: "translate(193 263)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "kpmg-details_svg__cls-4",
    width: 6,
    height: 9.466,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "kpmg-details_svg__cls-5",
    x: 0.8,
    y: 0.8,
    width: 4.4,
    height: 7.866,
    rx: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-details_svg__Rectangle_413",
    "data-name": "Rectangle 413",
    className: "kpmg-details_svg__cls-1",
    transform: "translate(194 271.466)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "kpmg-details_svg__cls-4",
    width: 4,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "kpmg-details_svg__cls-5",
    x: 0.8,
    y: 0.8,
    width: 2.4,
    height: 2.4,
    rx: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-details_svg__Rectangle_414",
    "data-name": "Rectangle 414",
    className: "kpmg-details_svg__cls-1",
    transform: "translate(194.432 261.568)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "kpmg-details_svg__cls-4",
    width: 3,
    height: 3,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "kpmg-details_svg__cls-5",
    x: 0.8,
    y: 0.8,
    width: 1.4,
    height: 1.4,
    rx: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-details_svg__Ellipse_194",
    "data-name": "Ellipse 194",
    className: "kpmg-details_svg__cls-1",
    transform: "translate(198 266)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "kpmg-details_svg__cls-4",
    cx: 2,
    cy: 2,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "kpmg-details_svg__cls-5",
    cx: 2,
    cy: 2,
    r: 1.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-details_svg__Line_281",
    "data-name": "Line 281",
    strokeLinecap: "round",
    stroke: "#009ceb",
    strokeWidth: 1.6,
    fill: "none",
    d: "M190.5 273.5h6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-details_svg__Path_937",
    "data-name": "Path 937",
    strokeDasharray: "11 16",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    className: "kpmg-details_svg__cls-4",
    d: "M5.1 0A5.1 5.1 0 110 5.1 5.1 5.1 0 015.1 0z",
    transform: "scale(-1) rotate(-70 -293.884 11.181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.1 0a5.1 5.1 0 015.102 5.113V5.132a7.46 7.46 0 010 .011V5.162a5.087 5.087 0 010 .011v.007H10.2v.005a.554.554 0 010 .02v.024l-.001.005v.019a9.697 9.697 0 010 .012 4.879 4.879 0 01-.001.012v.013a4.651 4.651 0 01-.002.024V5.338a9.451 9.451 0 01-.001.006V5.362l-.001.006v.006a4.793 4.793 0 01-.001.011v.007a8.328 8.328 0 01-.002.017v.019l-.001.005v.007a4.581 4.581 0 010 .007l-.001.004v.001a4.732 4.732 0 01-.001.011v.012l-.001.002a8.687 8.687 0 010 .01v.002l-.001.005V5.5a.579.579 0 00-.001.007v.007l-.001.005v.007l-.001.005a3.825 3.825 0 01-.001.012v.007l-.002.01v.006a3.138 3.138 0 010 .008l-.001.004a4.712 4.712 0 01-.001.012 4.724 4.724 0 01-.002.012v.012l-.001.006v.006h-.001a4.941 4.941 0 010 .007l-.001.004v.007l-.001.005v.002l-.001.005a3.816 3.816 0 01-.001.012l-.001.005v.007l-.001.005v.001l-.001.006v.005a.581.581 0 00-.001.006l-.001.006v.001a3.53 3.53 0 010 .005l-.001.006a.717.717 0 00-.001.005v.006l-.001.002a3.425 3.425 0 01-.001.01v.002l-.001.004v.006l-.001.002a5.992 5.992 0 01-.001.01v.001l-.001.004v.002l-.001.005v.007l-.002.005v.007l-.001.004v.006l-.001.001v.006l-.002.005v.006l-.001.005v.002l-.001.005-.001.005v.006l-.001.001v.005l-.001.002v.004l-.001.006v.001l-.001.005-.001.006-.001.005v.001l-.001.005v.006l-.001.001a4.24 4.24 0 01-.002.01v.007l-.001.001a5.117 5.117 0 01-.003.016v.008l-.001.003v.002a7.988 7.988 0 01-.003.012v.006l-.001.004v.001l-.002.005v.007l-.001.005-.001.005v.002l-.001.004v.001a3.69 3.69 0 01-.003.012v.006l-.002.004v.001a3.846 3.846 0 01-.002.01v.007l-.001.001v.004l-.001.002-.001.004v.002l-.001.003v.002l-.001.005v.002l-.001.003v.002l-.001.005v.001l-.001.004v.002l-.002.004v.005l-.001.002v.005l-.001.001-.001.004v.002l-.001.005-.001.005v.001l-.002.005v.005l-.001.002v.005h-.001l-.001.005v.002l-.001.003v.002l-.001.004v.002l-.001.004v.001l-.002.005v.005l-.001.002-.001.004v.002l-.001.004v.001l-.002.005v.002a1.862 1.862 0 01-.001.005l-.001.004v.002l-.001.003v.002l-.002.005v.005l-.001.002-.001.004v.003l-.001.002v.002a4.182 4.182 0 01-.003.01v.002l-.001.003-.001.004v.002l-.001.003v.003l-.001.003-.001.003v.002l-.001.003-.001.003v.003l-.001.002-.001.003v.004l-.002.003v.005l-.002.003v.003a2.563 2.563 0 01-.003.012v.002l-.001.002a3.29 3.29 0 01-.002.007v.002l-.001.003v.003l-.002.003v.005l-.001.003-.001.004-.001.002v.002a2.93 2.93 0 01-.002.007v.003l-.001.002-.001.003v.002l-.002.004v.005l-.002.002v.004l-.001.003v.002l-.001.003-.002.004v.002a3.706 3.706 0 01-.003.01v.004a.693.693 0 01-.003.007v.005h-.001a6.992 6.992 0 01-.002.008v.003l-.001.001a4.989 4.989 0 01-.003.01v.001a4.764 4.764 0 01-.002.007l-.001.004-.002.007-.001.004v.001a5.126 5.126 0 01-.003.01v.002l-.003.01a4.544 4.544 0 01-.004.011v.001a4.484 4.484 0 01-.003.01v.001a5.845 5.845 0 01-.01.033v.001a5.04 5.04 0 01-.006.023l-.002.003a4.428 4.428 0 01-.01.034 5.077 5.077 0 01-.628 1.327.8.8 0 01-1.331-.888c.38-.573.582-1.241.582-1.933C8.602 3.17 7.032 1.6 5.1 1.6a3.496 3.496 0 00-2.93 1.583.8.8 0 11-1.337-.878A5.108 5.108 0 013.918.138l.015-.004.016-.003.004-.001.019-.005.035-.007.004-.001.011-.003h.004L4.042.11h.004l.016-.004h.004l.011-.003h.004l.001-.001h.003a.145.145 0 00.011-.003H4.1a.469.469 0 01.004-.002 5.416 5.416 0 01.012-.002h.004l.011-.003h.005L4.139.09A.471.471 0 004.15.088h.005l.003-.001A.232.232 0 014.17.085l.004-.001h.004l.008-.002h.003L4.191.08h.004L4.198.08a3.872 3.872 0 01.008-.002h.004l.003-.001h.001l.01-.002h.005L4.23.073h.004A4.586 4.586 0 014.245.07h.008L4.26.068h.005l.003-.001h.002l.003-.001.007-.001h.004l.001-.001h.004L4.3.062h.002l.002-.001h.005L4.31.06h.004L4.316.06h.005l.002-.001h.005L4.33.057h.004l.002-.001h.003a1.574 1.574 0 01.004-.001h.005l.001-.001h.005l.002-.001h.004l.003-.001h.002l.01-.002h.008L4.385.05A4.617 4.617 0 014.4.048h.006a5.402 5.402 0 01.01-.002h.004L4.42.044h.002A.956.956 0 004.43.044h.004l.002-.001h.004L4.45.04h.006L4.46.04h.006l.002-.001h.007l.002-.001h.005l.004-.001a1.85 1.85 0 01.005 0l.002-.001h.007l.003-.001h.006L4.51.033a42.208 42.208 0 01.004 0l.003-.001h.002a6.38 6.38 0 01.009-.001h.007L4.537.03h.006L4.545.03h.008l.002-.001a4.133 4.133 0 01.005 0l.004-.001h.006l.003-.001h.006l.005-.001h.002a1.411 1.411 0 01.004 0l.003-.001h.008l.003-.001h.007l.003-.001h.008l.002-.001h.01L4.637.02h.008A1.288 1.288 0 014.65.02h.005l.002-.001h.008A1.435 1.435 0 014.67.017h.002A3.458 3.458 0 014.68.017h.011a6.923 6.923 0 01.006-.001h.005l.003-.001h.006a6.832 6.832 0 01.007 0l.003-.001h.011l.001-.001H4.747l.002-.001H4.762A1.51 1.51 0 004.775.01h.019l.002-.001h.008a.885.885 0 00.006 0h.001l.004-.001h.01L4.83.006h.015a.277.277 0 00.006-.001h.021l.001-.001H4.894l.003-.001h.012a3.999 3.999 0 01.009 0h.001l.004-.001a.365.365 0 00.006 0h.02a.856.856 0 01.005 0l.002-.001h.003a.615.615 0 01.006 0H4.996L4.997 0h.019a1.046 1.046 0 01.006 0h.005a.804.804 0 01.005 0h.005a.61.61 0 00.006 0h.001a2.725 2.725 0 01.009 0h.006a3.836 3.836 0 01.01 0h.006A5.01 5.01 0 015.09 0H5.1z",
    fill: "#009ceb",
    transform: "scale(-1) rotate(-70 -293.884 11.181)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-details_svg__Rectangle_415",
    "data-name": "Rectangle 415",
    className: "kpmg-details_svg__cls-1",
    transform: "translate(196 276)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "kpmg-details_svg__cls-4",
    width: 3,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "kpmg-details_svg__cls-5",
    x: 0.8,
    y: 0.8,
    width: 1.4,
    height: 0.4,
    rx: 0.2
  })))));
}

export default SvgKpmgDetails;